<button
  *ngIf="fcWidget.isInitialized()"
  class="btn btn-icon-only btn-lg"
  (click)="toggleShowChat()"
  gtagEvent
  trackOn="click"
  action="ChartWithSupport_Panel"
  category="ChartWithSupport"
  [params]="{ event_label: 'Chart With Support clicked' }"
  tooltip="{{ tooltipText }}"
  placement="bottom"
>
  <i class="modus-icons notranslate">chat</i>
</button>
